import React, { Component } from 'react';
import PropTypes from 'prop-types';
import './Error.css';

class Error extends Component {
	render() {
		return <div className="errorText">{this.props.text}</div>;
	}
}

Error.propTypes = {
	text: PropTypes.string,
};

Error.defaultProps = {
	text: '',
};

export { Error };



// WEBPACK FOOTER //
// ./src/components/common/error/Error.js